import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-riskprofile-model',
  templateUrl: './riskprofile-model.component.html',
  styleUrls: ['./riskprofile-model.component.scss']
})
export class RiskprofileModelComponent implements OnInit {

  constructor(
    private BsModalService: BsModalService,
    private bsModalRef: BsModalRef,
    private modalService: NgbModal,
    private EncrdecrService: EncrdecrService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  EnableRiskProfile: string = '';
  RiskProfileStatus: string = '';
  UserType: string = '';
  RiskProfile: string = '';
  LastRPUpdateDate: string = '';
  ModalText: string = '';
  RiskProfileResponseMessage_data: any = '';

  ngOnInit() {
    if (sessionStorage.getItem('cIe+MhBUozWO3+mKZd2to=') != null && sessionStorage.getItem('cIe+MhBUozWO3+mKZd2to=') != undefined) {

      this.EnableRiskProfile = sessionStorage.getItem('cIe+MhBUozWO3+mKZd2to=');
      this.RiskProfileStatus = this.EncrdecrService.getDecr(sessionStorage.getItem('aaIHl0pIiYe71gyyxC/5xA=='));
      this.RiskProfile = this.EncrdecrService.getDecr(sessionStorage.getItem('AqVk7klfa+b0nlVjO8Y90I='));
      // this.LastRPUpdateDate = this.EncrdecrService.getDecr(sessionStorage.getItem('6l0NqN5kkIZCaDvdzUfYVK8g='))
      console.log("Risk Profile Status = " + this.RiskProfileStatus);

      if (this.RiskProfileStatus == "Not Available" || this.RiskProfileStatus == "Pending") {
        this.ModalText = "You have not yet set your risk profile. Please select your risk category below to continue with your investments."
      }
      else if (this.RiskProfileStatus == "Expired") {
        this.ModalText = "Your risk profile has not been updated in the last 12 months. To continue making informed investment desicions, please select your preferred risk category below."
      }
    }
    if (sessionStorage.getItem('L2D3506kIHSk3E0') != undefined
      && sessionStorage.getItem('L2D3506kIHSk3E0') != null) {
      this.UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    }
    // this.RiskProfileResponseMessage_data = this.RiskProfileResponseMessage;
  }
  Get_RiskProfileResponseMessage(event) {
    this.RiskProfileResponseMessage_data = event;
    console.log("Risk Profile Message", event);
    // if(this.isNullOrUndefined(event)){
    this.HideRiskModalPopup();
    // this.CallAlertModal(event);
    // }

  }
  isNullOrUndefined(object: unknown) {
    let val: boolean = false;
    if (object == null || object == undefined) {
      val = true;
    }
    return val;
  }
  HideRiskModalPopup() {
    this.bsModalRef.hide();
  }

  CallClientProfile() {
    sessionStorage.setItem("J1hcKSsVOAGi13tEWI9TVtZYRzE=", 'RiskProfile')
    this.router.navigate(["/client-profile"], {
      relativeTo: this.route,
    });
    this.bsModalRef.hide();
    
  }
  CallAlertModal(msg: any) {
    $("select").select2("close");
    $("#AlertModalprofilemodels").modal({
      backdrop: "static",
      keyboard: false,
    });
    $("#AlertModalprofilemodelsContentmodels").text(msg);
  }
  modalClose() {
    if (this.UserType == '3' && this.router.url == '/client-dashboard') { //if client and on dashboard then close the popup
      this.bsModalRef.hide();
    }
    else if (this.UserType == '3' && this.router.url != '/client-dashboard') { //if client and on transaction pages then close the popup and go to dashboard
      this.bsModalRef.hide();
      // this.router.navigate(['/client-dashboard'])
      window.location.href = '/client-dashboard';
    }
    else if (this.UserType != '3' && this.router.url != '/client-dashboard') { //if SB/RM and on transaction pages then close popup only
      this.bsModalRef.hide();
    }
  }
}
